module.exports = __webpack_public_path__ + "img/a44.fa863b04.png";